export const DOUGHNUT_OPTIONS = {
  scales: false,
  cutoutPercentage: 80,
  legend: false,
  tooltips: false,
};
